import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class EmailsEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      email_id: '',
      name: '',
      email: '',
      data: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.addToEmail = this.addToEmail.bind(this);
    this.loadData = this.loadData.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/email/editar/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/emails');
        if (responseJson.status === 'success') {
          self.setState({
            email_id: responseJson.data.id,
            name: responseJson.data.name,
          });
        }
      }).then(() => {
      var url = config.get('api') + '/email/enderecos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* Endereços */
    });
  }
  
  // Fetch salvando a edição
  addToEmail(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      email_id: this.state.email_id,
      email: this.state.email,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/email/endereco', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          var data_temp = self.state.data;
          data_temp.push(responseJson.data);
          self.setState({data: data_temp});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {

    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }
  
  delete (event) {
    var email_address_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse endereço de email?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/email/endereco/' + email_address_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(email_address_id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  deleteRow(email_address_id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == email_address_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }
  

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">E-mail destinatários - {this.state.name}</h3>
      <Link to="/emails" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <h4>Cadastrar e-mail</h4>
      <hr/>
      <form onSubmit={this.addToEmail}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>E-mail:</label>
              <input type="text" name="email" className="form-control" placeholder="" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label></label>
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
            </div>
          </div>
        </div>
      </form>
      <hr/>
      <h4>E-mails cadastrados</h4>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há emails cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>
        <TableHeaderColumn dataField="email_address" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Tipo de envio</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default EmailsEdit;



// WEBPACK FOOTER //
// ./src/Components/Emails/EmailsEdit.js